import React, { Component } from "react";
import PropTypes from "prop-types";
import Image from "@components/image";
import cx from "classnames";

export default class XSlider extends Component {
  constructor() {
    super();
    this.state = {
      current: 0,
      disabled: {
        "-1": true, // 回退，左按钮
        1: false, // 前进，右按钮
      },
      flag: null,
      max: 0,
      static: true,
    };
  }
  componentWillMount() {
    const l = this.props.slides.length;
    this.setState({
      flag: {
        "-1": 0,
        1: l > 0 ? l - 1 : 0,
      },
    });
  }
  componentDidMount() {
    const jumpTo = this.props.jumpTo;
    // 第一次，对=0，不需要jumpTo
    jumpTo > 0 && this.switch(1, jumpTo);
    this.setState({ static: false });
  }
  componentWillReceiveProps(nextProps) {
    const jT = nextProps.jumpTo;
    const oldJT = this.props.jumpTo;
    const current = this.state.current;
    if (jT >= 0 && jT !== oldJT && jT !== current) {
      const istep = jT - current;
      const step = Math.abs(istep);
      this.switch(step / istep, step);
    }
  }
  render() {
    const { text } = this.props;
    const { disabled, current, static: isStatic } = this.state;
    // msTransform: 用于IE9，对象是无序的，transform可能被msTransform覆盖，不过，不会
    const L = this.props.slides.length;
    const displayProgress = this.props.displayProgress;
    const moreThanOne = L > 1;
    return (
      <div className={cx("x-slider", this.props.className, { ["x-slider--static"]: this.state.static })}>
        <ul
          className="x-slides"
          style={{
            msTransform: `translateY(-${current * 100}%)`,
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {this.renderSlides()}
        </ul>
        {moreThanOne &&
          [
            !isStatic && (
              <button
                key="switch:prev"
                className="x-slider-switch prev x-slider-switch--prev"
                disabled={disabled["-1"]}
                onClick={e => {
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  e.preventDefault();
                  this.switch(-1);
                }}
                aria-label={text.prev}
              />
            ),
            !isStatic && (
              <button
                key="switch:next"
                className="x-slider-switch next x-slider-switch--next"
                disabled={disabled[1]}
                onClick={e => {
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  e.preventDefault();
                  this.switch(1);
                }}
                aria-label={text.next}
              />
            ),
            displayProgress && (
              <i key="slide:progress" className="slide-progress">
                {current + 1}/{L}
              </i>
            ),
          ].filter(Boolean)}
      </div>
    );
  }
  renderSlides() {
    // 请不自作聪明改成：{ slides, onRenderSlide } = this.props
    const props = this.props;
    const { current, max } = this.state;
    return props.slides
      .map((slide, k) => {
        const ifRender = k <= max;
        if (!ifRender) return;
        return (
          <li key={k} className={cx("x-slide", current === k ? "current-slide" : "")}>
            {props.onRenderSlide(slide, current === k, k)}
          </li>
        );
      })
      .filter(Boolean);
  }
  switch(dir, step = 1) {
    const { current, flag, max } = this.state;
    let k;
    this.setState({
      current: (k = current + dir * step),
      disabled: {
        [dir]: k === flag[dir],
        [-dir]: k === flag[-dir],
      },
      max: Math.max(k, max),
    });
    this.props.onSwitch(current + dir * step);
  }
}

const { array, func, bool, object, string, number } = PropTypes;
XSlider.propTypes = {
  className: string,
  slides: array,
  onRenderSlide: func,
  autoPlay: bool, // 还没用，目前没这个应用场景
  keyMap: object,
  isFull: bool,
  displayProgress: bool,
  jumpTo: PropTypes.oneOfType([number, string]), // index，直接跳转到第jumpTo张
  onSwitch: PropTypes.func,
  text: PropTypes.object,
};

XSlider.defaultProps = {
  className: "",
  slides: [],
  // 请不要自作聪明改成：onRenderSlide: () => <img src={slide[this.keyMap.src]} />
  onRenderSlide: function(slide, isCurrent, k) {
    return <Image isFull={this.isFull} src={slide[this.keyMap.src]} loadit={isCurrent} />;
  },
  autoPlay: false,
  keyMap: { src: "src" },
  isFull: false,
  displayProgress: false,
  jumpTo: -1, // 不跳转
  onSwitch: () => {},
  text: {
    prev: "前一项",
    next: "后一项",
  },
};

require("./index.less");
require("./index.less");